import { render, staticRenderFns } from "./hand-halloween.vue?vue&type=template&id=06ebad8a&scoped=true"
import script from "./hand-halloween.vue?vue&type=script&lang=js"
export * from "./hand-halloween.vue?vue&type=script&lang=js"
import style0 from "./hand-halloween.vue?vue&type=style&index=0&id=06ebad8a&prod&scoped=true&lang=scss"
import style1 from "./hand-halloween.vue?vue&type=style&index=1&id=06ebad8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ebad8a",
  null
  
)

export default component.exports